import Cookies from 'js-cookie'
import { DateTime } from 'luxon'
import { useEffect, useState } from 'react'

/**
 * 最終チェック時刻を管理するカスタムフック
 *
 * @returns 前回オポチュニティ一覧をチェックした時刻（Unixタイムスタンプ秒）
 */
export function useLastCheckAt(): number {
  // lastCheckAt: 前回オポチュニティ一覧をチェックした時刻（Unixタイムスタンプ秒）
  // 初期化時にCookieから読み込むのみ（未設定時は1日前を基準とする）
  const [lastCheckAt] = useState<number>(() => {
    const cookieData: { lastCheckAt?: number } | null = JSON.parse(Cookies.get('captain-portal') || 'null')
    const oneDayAgo = Math.floor(DateTime.local().minus({ days: 1 }).toSeconds())
    return cookieData?.lastCheckAt || oneDayAgo
  })

  // コンポーネントのアンマウント時に現在時刻をCookieに保存
  useEffect(() => {
    return () => {
      const currentTimestamp = Math.floor(DateTime.local().toSeconds())
      Cookies.set('captain-portal', JSON.stringify({ lastCheckAt: currentTimestamp }), {
        secure: window.location.protocol === 'https:',
        expires: 30,
        path: '/',
      })
    }
  }, [])

  return lastCheckAt
}
